const ROOT = 'StepTwo/channelPublication/photoVignette';

export const POST_PHOTO_VIGNETTE_REQUEST = `${ROOT}/POST_PHOTO_VIGNETTE_REQUEST`;
export const POST_PHOTO_VIGNETTE_FAILURE = `${ROOT}/POST_PHOTO_VIGNETTE_FAILURE`;
export const POST_PHOTO_VIGNETTE_SUCCESS = `${ROOT}/POST_PHOTO_VIGNETTE_SUCCESS`;


export const SET_PHOTO_VIGNETTE_ALL = `${ROOT}/SET_PHOTO_VIGNETTE_ALL`;


export const CLEAR_PHOTO_VIGNETTE = `${ROOT}/CLEAR_PHOTO_VIGNETTE`;
export const CLEAR_PHOTO_VIGNETTE_ALL = `${ROOT}/CLEAR_PHOTO_VIGNETTE_ALL`;
